<template lang="pug">
.company-fields
  BriqInput(label="Company name" optional v-model="customer.CompanyName")
  BriqInput(label="Address" optional v-model="customer.CompanyAddress")
  .grid-1-2
    BriqInput(label="ZIP" optional v-model="customer.CompanyZipcode")
    BriqInput(label="City" optional v-model="customer.CompanyCity")
  BriqCountrySelect(
    label="Country"
    name="CompanyCountryCode"
    v-model="customer.CompanyCountryCode"
    :options="countries"
    optional
    )
  BriqInput(label="Company e-mail" optional v-model="customer.CompanyEmail")
  BriqInput(label="Company phone" optional v-model="customer.CompanyPhonenumber")
  BriqInput(label="VAT number" optional v-model="customer.CompanyTaxNumber")
  BriqInput(label="Chamber of Commerce" optional v-model="customer.CompanyCocNumber")
  BriqTextarea(label="Additional (e.g. mailing reference)" optional v-model="customer.CustomReference")
</template>

<script>
import BriqCountrySelect from '@v/components/BriqCountrySelect.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'CompanyFields',
  components: { BriqCountrySelect },
  props: {
    customer: Object,
  },
  computed: mapGetters('briqState', ['countries']),
}
</script>

<style scoped lang="stylus">
.grid-1-2
  display grid
  grid-template-columns 1fr 2fr
  grid-gap 15px
  margin-bottom 20px
</style>

<style lang="stylus">
.company-fields .briq-form-element
  margin-bottom 24px
</style>
